module.exports = __webpack_public_path__ + "static/media/date-range-arrow-left-focused.8191f27a.svg";